import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Ensures every route change starts at the top of the page.
 * When the URL contains a hash (e.g. `/#gallery`) we scroll to the matching
 * element after a short delay so the target section has time to mount.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      // wait a tick for the target page/section to render
      const t = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          window.scrollTo({ top: 0, left: 0, behavior: "instant" });
        }
      }, 80);
      return () => clearTimeout(t);
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
